// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_reset.scss";
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_typography.scss";
import "../../css/pages/_integrations.scss";

import { initializeGeneralUtils } from "../src/general/utils";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTodosModal } from "../../../svelte/src/bindings/todos-modal";
import { initializeIntegrations } from "../src/dropdown/integrations/integrations.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeCleartext } from "../src/general/elements/cleartext.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeMarketingModal } from "../src/marketing/marketing.js";
import { initializeUploads } from "../src/uploads/uploads.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
bindTodosModal();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeVisibilities();
initializeIntegrations();
initializeSidebar();
initializeCleartext();
initializeTracking();
initializeWins();
initializeUploads();
initializeMarketingModal();
